module.exports = __webpack_public_path__ + "static/media/svix.cca5bc9e.svg";